import React from 'react';
import { connect } from 'react-redux';
import { movil } from '../app-movil';

const mapState = (state) => {
    return {
    	encPasoTres: state.miPerfil.encPasoTres,
		msjPasoTres: state.miPerfil.msjPasoTres
    };
}

const mapDispatch = (dispatch) => {
    return {
    	resetSiguienteContrasena: () => {
            dispatch({ "type": "MI_PERFIL_RESET_SIGUIENTE_CONTRASENA" });
        }
    }
}

class PasoTresContrasena extends React.Component {
	state = {

	}
	okContrasena = () => {
        let mensaje = {"return": "miPerfil", "proceso": "cambioContrasena"};
        movil("cambioContrasena", mensaje);
        this.props.resetSiguienteContrasena();
        this.setState({inputClassPassOld: "input-wrap ver-input"});
        this.setState({inputClassPassNew: "input-wrap ver-input"});
        this.setState({inputClassPassNewConf: "input-wrap ver-input"});
        this.setState({inputClassPreguntaPass: "input-wrap ver-input"});
        this.setState({inputActivePassOld: ""});
        this.setState({inputActivePassNew: ""});
        this.setState({inputActivePassNewConf: ""});
        this.setState({inputActivePreguntaPass: ""});
        this.setState({inputPassOldType: "password"});
        this.setState({inputPassNewType: "password"});
        this.setState({inputPassNewConfType: "password"});
        this.setState({inputPreguntaPassType: "password"});
        this.setState({oldPass: ""});
        this.setState({newPass: ""});
        this.setState({confPass: ""});
        this.setState({errorPregunta: false});
        this.setState({errorPreguntaContrasena: false});
        this.setState({intentoPregunta: 1});
        this.setState({preguntaCambiarContrasena: ""});
        this.setState({errorMsjPreguntaContrasena: ""});
        this.setState({respuestaCambiarContrasena: ""});
        $('#modal-editar-contrasena').modal('toggle');
    }

	render() {
		return <div>
            <h5>
                <i>
                    <img src={ require("../img/delete-pass.png") } />
                </i>{this.props.encPasoTres}
            </h5>
            <hr className="mt-34" />
            <div className="texto-17">
                <p>{this.props.msjPasoTres}</p>
            </div>
            <div className="row">
                <div className="col-xs-12">
                    <div className="text-center aceptar-cancelar-btn">
                        <a className="orange-btn" onClick={this.okContrasena}>Aceptar</a>
                    </div>
                </div>
            </div>
        </div>
	}
}

export default connect(mapState, mapDispatch)(PasoTresContrasena);



// WEBPACK FOOTER //
// ./src/miPerfil/pasoTresContrasena.cmpt.js